/*
 * 园区接口 - 补充
 * */
import request from "./.request";

/**
 * 查询公司下辖所有园区
 * @param {number} entrId 公司id 
 * @returns 
 */
export function getParksInEnterprise(entrId) {
  return request({
    url: `/park/${entrId}?by=enterprise`,
    method: 'get',
  })
}
/**
 * 根据地块id查询所在园区
 * @param {number} landId 
 * @returns 
 */
export function getParkOfLand(landId) {
  return request({
    url: `/park/${landId}?of=land`,
    method: 'get',
  })
}
/**
 * 根据园区id查询园区信息
 * @param {number} parkId 
 * @returns 
 */
  export function getPark(parkId) {
    return request({
      url: `/park/${parkId}?by=park`,
      method: 'get',
    })
}



// WEBPACK FOOTER //
// ./src/api/park2.js